export const NAME = `project`;
export const LINE_KWH = 0;
export const LINE_KW = 1;
export const STATUS_PROJECT_TYPE = 4;
